const MsgIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="#9A6EEA" stroke="#9A6EEA">
      <path
        d="M7.33337 2.53331H14.6667C16.3921 2.53331 17.5576 2.9642 18.2967 3.70329C19.0358 4.44238 19.4667 5.60788 19.4667 7.33331V14.6666C19.4667 16.3921 19.0358 17.5576 18.2967 18.2967C17.5576 19.0358 16.3921 19.4666 14.6667 19.4666H2.75004C2.63247 19.4666 2.53337 19.3675 2.53337 19.25V7.33331C2.53337 5.60788 2.96426 4.44238 3.70335 3.70329C4.44244 2.9642 5.60794 2.53331 7.33337 2.53331ZM6.41671 14.6791H12.8334C13.5958 14.6791 14.2209 14.0541 14.2209 13.2916C14.2209 12.5292 13.5958 11.9041 12.8334 11.9041H6.41671C5.65427 11.9041 5.02921 12.5292 5.02921 13.2916C5.02921 14.0541 5.65427 14.6791 6.41671 14.6791ZM6.41671 10.0958H15.5834C16.3458 10.0958 16.9709 9.47075 16.9709 8.70831C16.9709 7.94588 16.3458 7.32081 15.5834 7.32081H6.41671C5.65427 7.32081 5.02921 7.94588 5.02921 8.70831C5.02921 9.47075 5.65427 10.0958 6.41671 10.0958Z"
        strokeWidth="1.4"
      />
    </svg>
  )
}

export default MsgIcon
